import { Col, Container, Image, Row, Stack } from "react-bootstrap"
import { Link } from "react-router-dom";

const OurBlog = () => {
    return (
        <Container className="our-blog margin-bottom-70">
            <Row>
                <Col md="12">
                    <h6 className="section-title text-center m-0">Our <span>Blog</span></h6>
                    <p className="section-subtitle text-center">Latest Blog & News</p>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <Stack className="our-blog-list">
                        <Image src="/images/about-blog-img1.png" />
                        <Stack className="our-blog-list-content">
                            <label>Cras accumsan nulla nec lacus ultricies placerat.</label>
                            <p>Curabitur sagittis libero tincidunt tempor finibus. Mauris at dignissim ligula, nec tristique orci.</p>
                            {/* <Link to="" className="align-self-start read-more">
                                <span>Read More</span>
                                <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
                                    <path d="M6.62831 5.66747L1.49311 0.53226C1.30784 0.346994 1.01331 0.346994 0.832798 0.53226C0.652281 0.717527 0.652281 1.01205 0.832798 1.19257L5.64022 6L0.832798 10.8074C0.647531 10.9927 0.647531 11.2872 0.832798 11.4677C1.01331 11.6482 1.31259 11.653 1.49311 11.4677L6.62831 6.33253C6.69957 6.26127 6.74232 6.17101 6.75657 6.08075C6.78508 5.93349 6.74232 5.77673 6.62831 5.66747Z" fill="#FF4103"/>
                                </svg>
                            </Link> */}
                        </Stack>
                    </Stack>
                </Col>
                <Col md="4">
                    <Stack className="our-blog-list">
                        <Image src="/images/about-blog-img2.png" />
                        <Stack className="our-blog-list-content">
                            <label>Cras accumsan nulla nec lacus ultricies placerat.</label>
                            <p>Curabitur sagittis libero tincidunt tempor finibus. Mauris at dignissim ligula, nec tristique orci.</p>
                            {/* <Link to="" className="align-self-start read-more">
                                <span>Read More</span>
                                <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
                                    <path d="M6.62831 5.66747L1.49311 0.53226C1.30784 0.346994 1.01331 0.346994 0.832798 0.53226C0.652281 0.717527 0.652281 1.01205 0.832798 1.19257L5.64022 6L0.832798 10.8074C0.647531 10.9927 0.647531 11.2872 0.832798 11.4677C1.01331 11.6482 1.31259 11.653 1.49311 11.4677L6.62831 6.33253C6.69957 6.26127 6.74232 6.17101 6.75657 6.08075C6.78508 5.93349 6.74232 5.77673 6.62831 5.66747Z" fill="#FF4103"/>
                                </svg>
                            </Link> */}
                        </Stack>
                    </Stack>
                </Col>
                <Col md="4">
                    <Stack className="our-blog-list">
                        <Image src="/images/about-blog-img3.png" />
                        <Stack className="our-blog-list-content">
                            <label>Cras accumsan nulla nec lacus ultricies placerat.</label>
                            <p>Curabitur sagittis libero tincidunt tempor finibus. Mauris at dignissim ligula, nec tristique orci.</p>
                            {/* <Link to="" className="align-self-start read-more">
                                <span>Read More</span>
                                <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
                                    <path d="M6.62831 5.66747L1.49311 0.53226C1.30784 0.346994 1.01331 0.346994 0.832798 0.53226C0.652281 0.717527 0.652281 1.01205 0.832798 1.19257L5.64022 6L0.832798 10.8074C0.647531 10.9927 0.647531 11.2872 0.832798 11.4677C1.01331 11.6482 1.31259 11.653 1.49311 11.4677L6.62831 6.33253C6.69957 6.26127 6.74232 6.17101 6.75657 6.08075C6.78508 5.93349 6.74232 5.77673 6.62831 5.66747Z" fill="#FF4103"/>
                                </svg>
                            </Link> */}
                        </Stack>
                    </Stack>
                </Col>
            </Row>
        </Container>
    )
}

export default OurBlog;